import { useTranslation } from "react-i18next";

//Styles
import "./Stats.scss";

const Stats = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="stats">
        <div className="stats-title">
          <h2>{t("stats.title")}</h2>
        </div>
        <div className="stats-objetives">
          <div className="stats-objetives_div">
            <h3>
              <mark>{t("stats.title1")}</mark>
            </h3>
            <p>
              <mark>{t("stats.description1")}</mark>
            </p>
          </div>
          <div className="stats-objetives_div">
            <h3>
              <mark>{t("stats.title2")}</mark>
            </h3>
            <p>
              <mark>{t("stats.description2")}</mark>
            </p>
          </div>
          <div className="stats-objetives_div">
            <h3>
              <mark>{t("stats.title3")}</mark>
            </h3>
            <p>
              <mark>{t("stats.description3")}</mark>
            </p>
          </div>
          <div className="stats-objetives_div">
            <h3>
              <mark>{t("stats.title4")}</mark>
            </h3>
            <p>
              <mark>{t("stats.description4")}</mark>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Stats;
